/* istanbul ignore file */
import React from 'react';

import { isNewContributionExperienceEnabled, isNewWriterEditorEnabled } from '@lumapps/contents/ducks/selectors';
import { useSelector } from '@lumapps/redux/react';

import { useCustomContentTypes } from '../../hooks/useCustomContentTypes';
import { ContentContributionMenu, ContentContributionMenuProps } from './ContentContributionMenu';

const ConnectedContentContributionMenu: React.FC<Pick<ContentContributionMenuProps, 'shouldOpenInNewTab'>> = ({
    shouldOpenInNewTab,
}) => {
    const {
        allowedCustomContentTypes,
        parentCustomContentTypes,
        canDesignAuthorizations,
        isAllowed,
        isLoading,
        isSuperAdmin,
    } = useCustomContentTypes({});

    const isNewContributionExperienceFFEnabled = useSelector(isNewContributionExperienceEnabled);
    const isWriterEditorFFEnabled = useSelector(isNewWriterEditorEnabled);

    return (
        <ContentContributionMenu
            allowedCustomContentTypes={allowedCustomContentTypes}
            isAllowed={isAllowed}
            isSuperAdmin={isSuperAdmin}
            parentCustomContentTypes={parentCustomContentTypes}
            isLoadingCustomTypes={isLoading}
            canDesignAuthorizations={canDesignAuthorizations}
            isNewWriterEditorEnabled={isWriterEditorFFEnabled}
            isNewContributionExperienceEnabled={isNewContributionExperienceFFEnabled}
            shouldOpenInNewTab={shouldOpenInNewTab}
        />
    );
};

export { ConnectedContentContributionMenu as ContentContributionMenu };
